// extracted by mini-css-extract-plugin
module.exports = {"infoMessage":"InfoMessage_infoMessage__3qopS","title":"InfoMessage_title__3Rkgu bodySBold","icon":"InfoMessage_icon__3TXEd","buttonContainer":"InfoMessage_buttonContainer__SeQgM"};